// extracted by mini-css-extract-plugin
export default {"textareaWrap":"TaskTextarea_textareaWrap__UTvW0","text":"TaskTextarea_text__C5Uug","error":"TaskTextarea_error__OUcKM","errorMessage":"TaskTextarea_errorMessage__L5VVJ"};